
import "../Foundation/stylable/spacing.st.css.js";
import "../BaseModalLayout/BaseModalLayout.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_CustomModalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_CustomModalLayout__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-custom-modal-footer-padding-vertical":"--wds-custom-modal-footer-padding-vertical","wds-custom-modal-footer-padding-horizon":"--wds-custom-modal-footer-padding-horizon","wds-custom-modal-footnote-padding-horizon":"--wds-custom-modal-footnote-padding-horizon","wds-custom-modal-footnote-padding-vertical":"--wds-custom-modal-footnote-padding-vertical","wds-custom-modal-header-padding-vertical":"--wds-custom-modal-header-padding-vertical","wds-custom-modal-header-padding-right":"--wds-custom-modal-header-padding-right","wds-custom-modal-header-padding-left":"--wds-custom-modal-header-padding-left","wds-custom-modal-content-padding-horizon":"--wds-custom-modal-content-padding-horizon","wds-custom-modal-content-padding-vertical":"--wds-custom-modal-content-padding-vertical"}; 




